<mat-dialog-content>
  <div class="row mt-3 ml-2">
    <div class="col">
      <h1>{{'Private.Booking.SessionEvents.GuideTitle1' | translate}} {{ guideName }}
        {{'Private.Booking.SessionEvents.GuideTitle2' |
      translate}} {{ startTime | date: 'dd.MM.yyyy'}}</h1>
      <span class="mb-3">{{'Private.Booking.SessionEvents.GuideSubtitle' | translate}}</span>
      @if (!dataSource || dataSource.length == 0) {
        <span><br />{{ 'Shared.GuideCapacity.NoEvents' | translate
        }}</span>
      }
      @if (dataSource && dataSource.length > 0) {
        <table mat-table [dataSource]="dataSource" class="grid-table">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.StartDate' |
              translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.start | date: 'dd.MM.yyyy' }} </td>
          </ng-container>
          <ng-container matColumnDef="start">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.Start' | translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.start | date: 'HH:mm' }} </td>
          </ng-container>
          <ng-container matColumnDef="end">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.End' | translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.end | date: 'HH:mm' }} </td>
          </ng-container>
          <ng-container matColumnDef="prename">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.Prename' |
              translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.prename }} </td>
          </ng-container>
          <ng-container matColumnDef="surname">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.Surname' |
              translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.surname }} </td>
          </ng-container>
          <ng-container matColumnDef="grouptype">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.GroupType' |
              translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.groupType }} </td>
          </ng-container>
          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.Size' | translate
              }}
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.size }} </td>
          </ng-container>
          <ng-container matColumnDef="language">
            <th mat-header-cell *matHeaderCellDef> {{ 'Common.SessionGroupEventGuideListModel.Language' |
              translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.language }} </td>
          </ng-container>
          <ng-container matColumnDef="gdAStartTime">
            <th mat-header-cell *matHeaderCellDef> {{ 'Private.Session.Sessions.Calendar.Gda' |
              translate
            }} </th>
            <td mat-cell *matCellDef="let element"> {{ element.gdAStartTime ?? "" }} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="{ 'highlight-bg' : row.start == startTime }"></tr>
        </table>
      }
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <div class="custom-stepper-buttons">
        <button mat-raised-button color="basic" (click)="onCancel()">{{ 'Common.Close' | translate }}</button>
        <button mat-raised-button color="primary" class="next" (click)="onOpenCalendar()">{{
          'Common.OpenGuideCalendar' | translate }}<mat-icon class="icon">open_in_new</mat-icon></button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
